import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { GitCompare, X } from "lucide-react";
import { useCompare } from "@/lib/useCompare";
import { api } from "@/lib/api";

export default function CompareTray() {
  const { ids, remove, clear } = useCompare();
  const [deals, setDeals] = useState([]);
  const location = useLocation();

  useEffect(() => {
    if (ids.length === 0) { setDeals([]); return; }
    api.get("/compare", { params: { ids: ids.join(",") } })
      .then((r) => setDeals(r.data))
      .catch(() => setDeals([]));
  }, [ids.join(",")]);

  // Hide on compare page itself
  if (ids.length === 0 || location.pathname === "/compare") return null;

  return (
    <div
      className="fixed bottom-20 left-1/2 -translate-x-1/2 md:bottom-6 z-40 glass-strong rounded-2xl px-4 py-3 flex items-center gap-3 shadow-[0_20px_60px_rgba(0,0,0,0.6)] animate-fade-up max-w-[calc(100vw-2rem)]"
      data-testid="compare-tray"
    >
      <GitCompare className="w-4 h-4 text-silver flex-shrink-0" />
      <div className="flex items-center gap-2 overflow-x-auto">
        {deals.map((d) => (
          <div key={d.id} className="flex items-center gap-2 bg-white/5 px-2 py-1.5 rounded-full text-xs whitespace-nowrap" data-testid={`tray-item-${d.id}`}>
            <img src={d.image_url} alt="" className="w-6 h-6 rounded-full object-cover" />
            <span className="hidden sm:inline max-w-[120px] truncate">{d.brand} {d.model}</span>
            <button onClick={() => remove(d.id)} aria-label="Remove" className="text-gray-400 hover:text-white">
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
      </div>
      <Link
        to={`/compare?ids=${ids.join(",")}`}
        className="silver-gradient text-[#050507] px-4 py-2 rounded-full text-xs font-bold tracking-wide flex-shrink-0"
        data-testid="tray-compare-cta"
      >
        Compare ({ids.length})
      </Link>
      <button onClick={clear} className="text-gray-500 hover:text-white text-xs ml-1" data-testid="tray-clear" aria-label="Clear">Clear</button>
    </div>
  );
}
